import { SignIn } from '@clerk/react';

export function LoginPage(): JSX.Element {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f2f2f2' }}>
      <SignIn routing="path" path="/login" />
    </div>
  );
}
